import entity from './entity';

const {
  getAllFromState,
  getByIdFromState,
} = entity.getSelectors();

const state = {
  getEmployers: getAllFromState,
  getEmployerById: getByIdFromState,
};

export const {
  getEmployers,
  getEmployerById,
} = state;

export default state;
